import React, { useState, useEffect } from 'react';
import { UserAuth } from '../context/AuthContext';
import { useTheme  } from '../context/ThemeContext';
import { useNavigate } from 'react-router-dom';
import AlertPopup from './AlertPopup';
import NewTableComponent from './NewTable';
import Header from './header';
import ShareToWhatsApp from './share/ShareToWhatsApp';
import DownloadDocxButton from './share/DW';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import MarkupTextCopier from './pop/htmltomkd';
import {Sparkles,ArrowRight, Package, Zap, Crown, Heart, MessageSquare, ExternalLink, ChevronDown } from 'lucide-react';
import FilterModal from './FilterModal';
import { RefreshCw, Type, Filter, Send} from 'lucide-react';
import SaveQuestionButton from './pop/save';
import ExtendedActionButtons from './pop/extended_action';
import PlansPop from './layout/components/NewComponentNofetch';
import './Chat/chat.css'

const animations = [
  (<div className="loader"></div>),
  (<div aria-label="Orange and tan hamster running in a metal wheel" role="img" className="wheel-and-hamster">
    <div className="wheel"></div>
    <div className="hamster">
      <div className="hamster__body">
        <div className="hamster__head">
          <div className="hamster__ear"></div>
          <div className="hamster__eye"></div>
          <div className="hamster__nose"></div>
        </div>
        <div className="hamster__limb hamster__limb--fr"></div>
        <div className="hamster__limb hamster__limb--fl"></div>
        <div className="hamster__limb hamster__limb--br"></div>
        <div className="hamster__limb hamster__limb--bl"></div>
        <div className="hamster__tail"></div>
      </div>
    </div>
    <div className="spoke"></div>
  </div>),
  (<div className="loader2"></div>)
];

function AccountEngine() {
  // States
  const [useAduanerosLink, setUseAduanerosLink] = useState(false);
  const [isSideMenuVisible, setIsSideMenuVisible] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 944);
  const [loading, setLoading] = useState(false);
  const [inputText, setInputText] = useState('');
  const [respuesta, setRespuesta] = useState('');
  const [shareRespuesta, setShareRespuesta] = useState('');
  const [Titulo, setTitulo] = useState('');
  const [tabledatas, setTableDatas] = useState({});
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [localNotifications, setLocalNotifications] = useState([]);
  const [isNotificationPopupVisible, setIsNotificationPopupVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [isFeedbackExpanded, setIsFeedbackExpanded] = useState(false);
  const [fontSize, setFontSize] = useState(15);
  const [fontFamily, setFontFamily] = useState('var(--body-font)');
  const texto_warning_bloqueo = "\"Las cuentas gratuitas tienen derecho a 5 Preguntas Diarias, Has alcanzado el limite de navegación para ususarios gratuitos, contrata alguno de nuestros Planes para tener busquedas ilimitadas\"";
  const [isPromoVisible, setPromoVisible] = useState(false);
  const [shownTables, setShownTables] = useState({});
  const { isDarkMode, themeClass, toggleTheme } = useTheme();

  const {user, token, fetchNotifications, logout } = UserAuth();
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [isFilterExpanded, setIsFilterExpanded] = useState(false);
  const navigate = useNavigate();

  const documentLabels = {
    Constitucion: 'Constitucion',
    CodigoTrabajo: 'Codigo de Trabajo',
    CodigoCivil: 'Codigo Civil',
    CodigoPenal: 'Codigo Penal',
    LeyAmbiente: 'Ley de Medio Ambiente',
    LeyTransito: 'Ley de Transito',
    CodigoProcesalPenal: 'Codigo Procesal Penal',
    Codigocomercio: 'Codigo comercio',
    Codigotributario: 'Codigo tributario',
    LeydelIgss: 'Ley Organica del Instituto Guatemalteco de Seguridad Social',
    Leycontralavadodedinero: 'Ley contra el lavado de dinero u otros activos',
    ReglamentodeLeycontralavadodedinero: 'Reglamento de la Ley Contra el Lavado de Dinero u Otros Activos',
    Leydeextinsiondedominio: 'Ley de extincion de dominio',
    reglamendodeleydeextinsiondedominio: 'Reglamento de la Ley de Extincion de Dominio',
    leyorganismojudicial: 'Ley del Organismo Judicial',
    leydeserviciocivil: 'Ley de Servicio Civil',
    leycontraelfemicidio: 'Ley contra el femicidio y otras formas de violencia contra la mujer',
    leycontraviolenciasexual: 'Ley Contra la Violencia Sexual Explotacion y Trata de Personas',
    codigoprocesalcivil: 'Código Procesal Civil y Mercantil',
    codigodenotariado: 'Codigo de Notariado',
    leydeamparo: 'Ley de Amparo, Exhibición Personal y de Constitucionalidad',
    leydeemisiondelpensamiento: 'Ley de Emsión del Pensamiento',
    leydelordenpublico: 'Ley del Orden Público',
    leydeejecutivo: 'Ley Ejecutivo',
    proteccionybieneestaranimal: 'Proteccion y Bienestar Animal',
    tarjetasdecredito: 'Tarjetas de Credito',
    LeyOrganicaMinisterioPublico: 'Ley Organica del Ministerio Publico',
    LeyProteccionConsumidor: 'Ley de protección al consumidor y usuario',
    LeyIVA: 'Ley del impuesto del valor agregado',
    LeyEducacionNacional: 'Ley de Educación Nacional',
    LeyAccesoInformacion: 'Ley de Acceso a la Informacion Publica',
    LeyArmasMuniciones: 'Ley de Armas y Municiones',
    LeyContratacionesEstado: 'Ley de Contrataciones del Estado',
    LeyRegistroCatastral: 'Ley de Registro de Informacion Catastral',
    LeyArbitraje: 'Ley de Arbitraje',
    LeyImpuestoCirculacion: 'Ley del Impuesto sobre Circulación de Vehiculos Terrestres, Maritimos y Aereos',
    LeyProteccionNinezAdolescencia: 'Ley de proteccion integral de la ninez y adolescencia',
    LeyTimbreForense: 'Ley de Timbre Forense y Notarial',
    LeyTimbresFiscales: 'Ley del Impuesto de Timbres Fiscales y de Papel Sellado Especial para Protocolos',
    LeyRegistroSucesorios: 'Ley del Registro de Procesos Sucesorios',
    LeyTramitacionNotarial: 'Ley Reguladora de la Tramitación Notarial de Asuntos de Jurisdicción Voluntaria',
    ReglamentoTimbresFiscales: 'Reglamento de la Ley del Impuesto de Timbres Fiscales y de Papel Sellado Especial para Protocolos',
    ReglamentoTimbreForense: 'Reglamento de la Ley del Timbre Forense y Timbre Notarial',
  };

  const [documentFilters, setDocumentFilters] = useState(
    Object.keys(documentLabels).reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {})
  );

  function markdownToWhatsApp(text) {
    let whatsappFormattedText = text;
    whatsappFormattedText = whatsappFormattedText.replace(/(\*\*|__)(.*?)\1/g, '*$2*');
    whatsappFormattedText = whatsappFormattedText.replace(/(\*|_)(.*?)\1/g, '_$2_');
    whatsappFormattedText = whatsappFormattedText.replace(/~~(.*?)~~/g, '~$1~');
    whatsappFormattedText = whatsappFormattedText.replace(/^(\s*)#+([^\n]*)/gm, '$1*$2*');
    whatsappFormattedText = whatsappFormattedText.replace(/(\[)(.*?)(\])/g, '_$2_');
    whatsappFormattedText = whatsappFormattedText.replace(/\* /g, '*');
    whatsappFormattedText = whatsappFormattedText.replace(/ \*\n/g, '*\n');
    whatsappFormattedText = whatsappFormattedText.replace(/_ /g, '_');
    whatsappFormattedText = whatsappFormattedText.replace(/ _\n/g, '_\n');
    return whatsappFormattedText;
  }

  const handleFilterToggle = () => {
    setIsFilterVisible(!isFilterVisible);
    if (isFilterVisible) {
      setIsFilterActive(false);
      setDocumentFilters(Object.keys(documentFilters).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {}));
    }
  };

  const handleCheckboxChange = (event) => {
    const newFilters = {
      ...documentFilters,
      [event.target.name]: event.target.checked,
    };
    setDocumentFilters(newFilters);

    const isActive = Object.values(newFilters).includes(true);
    setIsFilterActive(isActive);
  };

  const countChecked = () => {
    return Object.values(documentFilters).filter(val => val).length;
  };

  const execute_new = async (e) => {
    setTableDatas({});
    setPromoVisible(false);
    e.preventDefault();
    pickRandomAnimation(); /*Para agarrar todas */
    //setCurrentAnimation(2); /*Para testear animación exacta */
    const checkedItems = Object.entries(documentFilters).filter(([key, value]) => value).map(([key]) => key);
    let Items = [];
    if (isFilterActive && checkedItems.length > 0) {
      Items = checkedItems.map(key => documentLabels[key]);
    }

    setLoading(true);
    setRespuesta("");
    setShareRespuesta("");

    const baseURL = useAduanerosLink ? `${process.env.REACT_APP_API_BASE_URL_ADUANAS}` : `${process.env.REACT_APP_API_BASE_URL}`;
    //console.log('Base normal:', process.env.REACT_APP_API_BASE_URL);
    //console.log('Base aduanas:', process.env.REACT_APP_API_BASE_URL_ADUANAS);

    const controller = new AbortController();
    const signal = controller.signal;

    try {
      const response = await fetch(`${baseURL}/api/execute`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ input: inputText, documents: Items }),
        signal: signal
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let chunks = '';
      let jsonBuffer = '';
      let isJson = false;

      reader.read().then(function processText({ done, value }) {
        if (done) {
          controller.abort();
          return;
        }

        let incoming_chunk = decoder.decode(value);

        if (incoming_chunk.includes("--JSON-START--")) {
          if (incoming_chunk.includes("--JSON-END--")) {
            const parts = incoming_chunk.split("--JSON-START--");
            const textPart = parts[0];
            const jsonPart = parts[1].split("--JSON-END--")[0];
            chunks += textPart;
            jsonBuffer += jsonPart;

            const sanitizedHTML = DOMPurify.sanitize(marked.parse(chunks));
            setRespuesta(sanitizedHTML);
            setShareRespuesta(chunks);

            try {
              const jsonData = JSON.parse(jsonBuffer);
              setTableDatas(jsonData);
            } catch (error) {
              console.error("Failed to parse JSON part:", error);
            }

            controller.abort();
            return;
          } else {
            const parts = incoming_chunk.split("--JSON-START--");
            const textPart = parts[0];
            jsonBuffer = parts[1];

            chunks += textPart;
            
            const sanitizedHTML = DOMPurify.sanitize(marked.parse(chunks));
            setRespuesta(sanitizedHTML);
            setShareRespuesta(chunks);

            isJson = true;
          }
        } else if (incoming_chunk.includes("--JSON-END--")) {
          const parts = incoming_chunk.split("--JSON-END--");
          jsonBuffer += parts[0];

          try {
            const jsonData = JSON.parse(jsonBuffer);
            setTableDatas(jsonData);
          } catch (error) {
            console.error("Failed to parse JSON part:", error);
          }

          controller.abort();
          return;
        } else {
          if (isJson) {
            jsonBuffer += incoming_chunk;
          } else {
            chunks += incoming_chunk;
            console.log(chunks)
            if ( texto_warning_bloqueo === chunks)
            {
              setPromoVisible(true);}
            const sanitizedHTML = DOMPurify.sanitize(marked.parse(chunks));
            setRespuesta(sanitizedHTML);
            setShareRespuesta(chunks);
          }
        }

        return reader.read().then(processText);
      }).then(async () => {
        pickRandomAnimation();
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      console.log("error", error)
      console.log("error name",error.name)
      console.log("error message",error.message)
      console.log("error stack",error.stack)
      if (error.stack && error.stack.includes('429')) {
        setRespuesta("Demasiados requests, tu cuenta ha sido bloqueada, intentalo de nuevo más tarde");
      } else if (error.response && error.response.status === 403) {
        setRespuesta("Tu sesión expiró, por favor recarga la página o inicia sesión de nuevo.");
      } else if (error.response && error.response.status === 400) {
        setRespuesta("Ingrese un texto adecuado o su consulta es demasiado larga.");
      } else {
        setRespuesta("Tu sesión expiró, por favor recarga la página o inicia sesión de nuevo.");
      }
    }
  };

  const manuelfilro = () => navigate('/manual#Filtros');

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 900);

    const handleClickOutside = (event) => {
      if (isMobileView && isSideMenuVisible && !document.querySelector('.left-side').contains(event.target) && !document.querySelector('.hamburger-menu').contains(event.target)) {
        setIsSideMenuVisible(false);
      }
    };

    window.addEventListener('resize', handleResize);
    document.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isSideMenuVisible]);

  useEffect(() => {
    const getNotifications = async () => {
      const fetchedNotifications = await fetchNotifications();
      setLocalNotifications(fetchedNotifications);
    };

    getNotifications();
  }, []);

  const sortedTableDatas = Object.entries(tabledatas).sort(([, dataA], [, dataB]) => parseFloat(dataB[0].score) - parseFloat(dataA[0].score)).reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

  const updateTableShownState = (title, isShown) => {
    setShownTables(prev => ({...prev, [title]: isShown}));
  };
  const isAnyTableShown = Object.values(shownTables).some(value => value);

  const pickRandomAnimation = () => {
    const randomIndex = Math.floor(Math.random() * animations.length);
    setCurrentAnimation(randomIndex);
  };
  const [currentAnimation, setCurrentAnimation] = useState(0);
  const welcomeMessage = `Consulta lo que necesites${user.displayName ? " "+user.displayName.split(' ')[0] : ''}...`;


  return (
    <div className={`content-section ${themeClass}`}>
      <div className={`header-chat still ${themeClass}`} >
        <Header 
          countChecked={countChecked} 
        />
        |
        {/* Toggle de Tema */}
          <div className="theme-toggle small-toggle">
            <span className="colorIconToggle">☼</span>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={isDarkMode}
                onChange={toggleTheme}
                className="toggle-input"
              />
              <span className={`toggle-slider ${themeClass}`}>
                <span className={`toggle-knob ${themeClass}`} />
              </span>
            </label>
            <span className="colorIconToggle">☽</span>
          </div>
        </div>

      {isNotificationPopupVisible && (
        <AlertPopup
          title={localNotifications[0].titulo}
          message={localNotifications[0].texto}
          onClose={() => setIsNotificationPopupVisible(false)}
        />
      )}
      {isAlertVisible && (
        <AlertPopup
          title="Alerta"
          message="POR FAVOR, SELECCIONA AL MENOS UNA LEY O DESACTIVA EL FILTRO DE LEYES"
          onClose={() => setIsAlertVisible(false)}
        />
      )}

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        documentLabels={documentLabels}
        documentFilters={documentFilters}
        onFilterChange={handleCheckboxChange}
        countChecked={countChecked}
      />

      {/* Contenedor con centrado dinámico */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: respuesta ? 'flex-start' : 'center',
        minHeight: respuesta ? 'auto' : 'calc(100vh - 100px)',
        transition: 'all 0.3s ease',
        alignItems: 'center',
      }}>
        <h1 className={`title-chat ${themeClass}`} style={{
          marginTop: respuesta ? '20px' : '0',
          transition: 'margin-top 0.3s ease'
        }}>
          ¿En qué puedo ayudarte?
        </h1>

        <form onSubmit={execute_new}>
          <textarea
            type="text"
            className={`chatMess ${themeClass}`}
            placeholder={welcomeMessage}
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            required
          />
          
          <div className="form-controls">
            <div className='form-controlsFilters'> 
              <div className="filter-button-wrapper">
                <button 
                  type="button" 
                  className="filter-toggle-btn"
                  onClick={() => setIsFilterModalOpen(true)}
                >
                  <Filter size={18} />
                  <span>Búsqueda filtrada</span>
                </button>
              </div>

              <div className="checkbox-wrapper">
                <input
                  type="checkbox"
                  id="regimen-aduanero-sat"
                  checked={useAduanerosLink}
                  onChange={() => setUseAduanerosLink(!useAduanerosLink)}
                />
                <label htmlFor="regimen-aduanero-sat">
                  <span className="checkbox-label-full">Si tu pregunta tiene que ver con Aduanas o SAT activa este botón</span>
                  <span className="checkbox-label-mobile">Pregunta relacionada con Aduanas o SAT</span>
                </label>
              </div>
            </div>

            <button 
              className={`search-button ${themeClass}`}
              type="submit" 
              disabled={loading || (isSideMenuVisible && isMobileView)}
            >
              ↑
            </button>
          </div>
        </form>
        <div className='countselections'>
          {countChecked() > 0 && (
            <div className="leyes-badge">
              Leyes seleccionadas: <span className="leyes-count">{countChecked()}</span>
            </div>
          )}
        </div>
        {loading && (
          <div className="loader-container">
            {/* <p style={{color: 'red'}}>index: {currentAnimation}</p> */}
            {animations[currentAnimation]}
          </div>
        )}
      </div>

      {respuesta && (
        <div className={`AI-answer ${themeClass}`}>
          <div className="font-controls">
            <div className="font-control-group">
              <label htmlFor="fontSizeSlider" className="font-control-label">
                <Type size={18} />
                <span>Tamaño</span>
              </label>
              <input
                id="fontSizeSlider"
                type="range"
                min="14"
                max="32"
                value={fontSize}
                onChange={(e) => setFontSize(e.target.value)}
                className="font-slider"
              />
              <button
                onClick={() => setFontSize(18)}
                className="reset-font-btn"
              >
                <RefreshCw size={16} />
              </button>
            </div>

            <div className="font-control-group">
              <label htmlFor="fontFamilySelect" className="font-control-label">
                <Type size={18} />
                <span>Fuente</span>
              </label>
              <div className="font-select-wrapper">
                <select
                  id="fontFamilySelect"
                  value={fontFamily}
                  onChange={(e) => setFontFamily(e.target.value)}
                  className="font-select"
                >
                  <option value="var(--body-font)">Normal</option>
                  <option value="OpenDyslexic">Para Disléxicos</option>
                  <option value="Rumiko Clear">Rumiko</option>
                </select>
                <ChevronDown size={16} className="select-icon" />
              </div>
            </div>
          </div>

          <div 
            id="parrafo"
            style={{
              fontSize: `${fontSize}px`,
              fontFamily: fontFamily,
            }}
          >
            <p dangerouslySetInnerHTML={{ __html: respuesta.replace(
              /<table/g, 
              '<div class="table-scroll-wrapper"><table'
            ).replace(
              /<\/table>/g, 
              '</table></div>'
            )}}></p>
          </div>

          {isPromoVisible && <PlansPop />}
          
          <ExtendedActionButtons 
            pregunta={inputText}
            textToSave={shareRespuesta}
            posicion="center"
          />

          <div className='content-section without'></div>
          <MarkupTextCopier originalMarkup={shareRespuesta} />
          <div className='content-section'></div>
          
          <div className="content-section-title">
            Complementa tu consulta con los siguientes Artículos:
          </div>
          
          <div className={`tablas ${themeClass}`}>
            {Object.entries(sortedTableDatas).map(([title, data], index) => (
              <NewTableComponent 
                key={title} 
                title={title} 
                data={data} 
                themeClass={themeClass}
                isShown={shownTables[title] || false}
                updateShownState={(isShown) => updateTableShownState(title, isShown)}
                isAnyTableShown={isAnyTableShown}
              />
            ))}
          </div>
        </div>
      )}
      
      <div className='content-section'></div>
      <div className='content-section'></div>
      <div className='content-section'></div>
      <div className='content-section'></div>
      <div className='content-section'></div>
      <div className='content-section'></div>
    </div>
  );
}

export default AccountEngine;